module.exports = __webpack_public_path__ + "static/media/worry-1.8b7bd411.jpg";